var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{ref:"dp",staticClass:"p-period-picker",attrs:{"min":_vm.min,"max":_vm.max,"landscape":_vm.landscape,"multiple":_vm.multiple,"full-width":_vm.fullWidth,"title-date-format":_vm.titleDateFormat},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }